import { defaultData } from "../utils/default-data";
import { local } from "../utils/local-data";

export const state = {
  currentPage: 1,
  rows: [],
  columns: [],
  columnOrder: [],
  loading: true,
  error: "",
  pages: [
    {
      name: "Default",
      _id: 1,
      data: defaultData,
    },
    {
      name: "Local",
      _id: 2,
      data: local,
    },
  ],
  paginationModel: {
    pageNo: 1,
    limit: 20,
  },
};

export default state;
